class PredefinedDiscountController extends AbstractEntityEditController
	@register()
	@inject '$filter',
		'categories'
		'productFilters'
		'customerGroups'
		'discountData'
		'discountBenefitProductCategories'
		'Guid'
		'PromotionRepository'
		'CouponsTypeRepository'
		'EntityAttributeService'
		'PromotionCampaignService'
		'CopyService'
		'BACKEND_PROMOTION_QUALIFICATION_TYPE'
		'BACKEND_PROMOTION_BENEFIT_TYPE'
		'BACKEND_PROMOTION_CAMPAIGN_ENTITY_TYPE'
		'DATE_FORMAT'
		'ConfigurationService'

	initialize: ->
		@qualificationTypes = @BACKEND_PROMOTION_QUALIFICATION_TYPE
		@benefitTypes = @BACKEND_PROMOTION_BENEFIT_TYPE
		@endDateCache = null
		@shopsSearch = []
		@shopGroupsSearch = []
		@shops = []
		@shopGroups = []
		@attributesService = @EntityAttributeService.getNewInstance()
		@isShopGroupEnabled = @ConfigurationService.isEnabled 'Backoffice.ShopManagement.Shops.EnableShopGroups'

		if @discountData.id?
			@mainCrud.entityTitle = @discountData.name
			@mainCrud.isNewEntity = false
			@mainCrud.additionalButtons = [
				{
					action: 'copy'
					label: 'general.copy'
					confirmClick: => @copy()
					confirmClickLabel: 'general.copy.confirm'
				}
			]

			@discount =
				data: @discountData
				valid_forever: @discountData.date_to == null
				startDate: @discountData.date_from
				endDate: @discountData.date_to

			@discount.data.benefit_product_categories = _.map(
				@discountBenefitProductCategories,
				(item) -> item.product_category,
			)

			@discount.endDate = moment.unix(@discount.startDate).add(1, 'days').unix() if @discount.endDate == null
			@setDateCache @discount.data.date_to

			@discount.data.rank = parseInt(@discount.data.rank)
			@discount.data.benefit.percentage_off = parseInt(@discount.data.benefit.percentage_off)
			@discount.data.benefit.fixed_price = parseInt(@discount.data.benefit.fixed_price)

			@discount.data.shops.forEach (shop) =>
				@addShop shop

			if @discount.data.shop_groups?
				@discount.data.shop_groups.forEach (shopGroup) =>
					@addShopGroup shopGroup
		else
			@mainCrud.entityTitle = 'menu.predefined.discounts'
			@mainCrud.isNewEntity = true
			@discount =
				startDate: moment().unix()
				endDate: null
				valid_forever: true
				data:
					rank: 1
					name: null
					enabled: '0'
					description: null
					date_from: moment().unix()
					date_to: null
					benefit:
						promotion_benefit_type_id: null
					benefit_products: []
					benefit_product_categories: []

		@attributesService.setEntity @discount.data, 'BACKEND_PROMOTION_CAMPAIGN_ATTRIBUTE_TYPE', {external_id: null}
		@discount.data.entity_type = @BACKEND_PROMOTION_CAMPAIGN_ENTITY_TYPE.PREDEFINED_DISCOUNT
		@mainCrud.tabs = [
			{
				title: @$filter('translate')('bounty.step1.title')
				active: true
				selector: '#tab-step1'
			}
			{
				title: @$filter('translate')('bounty.step3.title')
				selector: '#tab-step2'
			}
			{
				title: @$filter('translate')('bounty.step4.title')
				selector: '#tab-step3'
			}
			{
				title: @$filter('translate')('bounty.step5.title')
				selector: '#tab-step4'
			}
		]

		@datePickerInfo =
			timePicker: true
			singleDatePicker: true
			format: @DATE_FORMAT

		@useCategoriesForBenefits = !_.isEmpty(@discount.data.benefit_product_categories)
		@initializeAllowedSelectionMaps()

	getDate: (unixTimestamp) ->
		return moment.unix(unixTimestamp).format(@DATE_FORMAT)

	updateDiscountDate: (actionType, timestamp) ->
		if actionType == 'from'
			@discount.data.date_from = timestamp
			dateTo = @discount.data.date_to || @getDateCache()

			if @discount.data.date_from > dateTo
				@discount.data.date_to = @discount.data.date_from if not @discount.valid_forever
				@discount.endDate = @discount.data.date_from
				@setDateCache @discount.endDate
		else
			@discount.data.date_to = timestamp

			if @discount.data.date_from > @discount.data.date_to
				@discount.data.date_from = @discount.data.date_to
				@discount.startDate = @discount.data.date_to

		@mainCrud.parent_form.$setDirty()

	toggleValidForever: ->
		if @discount.valid_forever
			@discount.data.date_to = null
		else
			@discount.data.date_to = @getDateCache()

	getDateCache: ->
		return @endDateCache || moment().unix()

	setDateCache: (newValue) ->
		if newValue != null
			@endDateCache = newValue

	searchShops: (searchTerm) ->
		@PromotionCampaignService
			.queryBenefitShops {name: searchTerm, ids: _.pluck(@shops, 'id')}
			.then (response) =>
				@shopsSearch = response
			.catch (response) =>
				@handleErrors(response, 'menu.predefined.discounts')

	addSearchShop: (shop) ->
		@shops = _.reject(@shops, {id: shop.id})
		@addShop shop

	searchShopGroups: (name) ->
		@PromotionCampaignService
			.queryShopGroups(name)
			.then (response) =>
				@shopGroupsSearch = response.data

	addSearchShopGroup: (shopGroup) ->
		@shopGroups = _.reject(@shopGroups, {id: shopGroup.id})
		@addShopGroup shopGroup

	addShopGroup: (shopGroup) ->
		shopGroup.selected = true
		@shopGroups.push shopGroup

	addShop: (shop) ->
		shop.selected = true
		@shops.push shop

	getSelectedCustomerGroupName: ->
		if @discount.data.required_customer_group_id
			name = _.find(@customerGroups, {id: @discount.data.required_customer_group_id}).name
		else
			name = @$filter('translate')('bounty.no.customer.group.needed')

		return name

	getBenefitTypeText: (typeId) ->
		switch typeId
			when @benefitTypes.PERCENTAGE_OFF_PER_ITEM then @$filter('translate')('bounty.predefined.benefit.type.percentage.off.item')
			when @benefitTypes.PERCENTAGE_OFF_SALE then @$filter('translate')('bounty.predefined.benefit.type.percentage.off.sale')
			when @benefitTypes.FREE_ITEM then @$filter('translate')('bounty.predefined.benefit.type.free.item')
			when @benefitTypes.FIXED_PRICE then @$filter('translate')('bounty.predefined.benefit.type.fixed.price')
			when @benefitTypes.FIXED_PRODUCT_PRICE then @$filter('translate')('wbo.promotion.benefit.type.fixed.product_price')
			when @benefitTypes.BUY_X_ITEMS_GET_PERCENTAGE_OFF_ITEM then @$filter('translate')('bounty.predefined.benefit.type.buy.x.items')
			when @benefitTypes.AMOUNT_OFF_SALE then @$filter('translate')('bounty.predefined.benefit.type.amount.off.sale')
			when @benefitTypes.AMOUNT_OFF_PER_ITEM then @$filter('translate')('bounty.predefined.benefit.type.amount.off.item')
			else 'benefitType'

	delete: ->
		@deleteEntity @PromotionRepository, @discountData

	copy: ->
		if @mainCrud.isNewEntity
			console.warn('Can not copy new entity')

			return

		data = @getPersistableData()
		data.required_coupon_type_id = @Guid.generate()

		@saveEntity(@CopyService.copyEntity(data, {root: ['promotion_id']}), true)

	save: ->
		@saveEntity(@getPersistableData())

	getPersistableData: ->
		@attributesService.persistAttributes()

		return @beforeSave()

	saveEntity: (data, isNewEntity = @mainCrud.isNewEntity) ->
		if @mainCrud.parent_form.$invalid
			return

		@PromotionRepository
			.save data, isNewEntity
			.then (response) =>
				if isNewEntity
					couponType =
						id: data.required_coupon_type_id
						name: response.data.id
						description: "CouponType for promotion  " + data.name
						single_use: "0"

					@CouponsTypeRepository
						.save couponType, true
						.then =>
							@afterSave response, @mainCrud.entityType, isNewEntity
						.catch (response) =>
							@handleErrors response
				else
					@afterSave response, @mainCrud.entityType, isNewEntity
			.catch (response) =>
				@handleErrors response

	beforeSave: ->
		discount = angular.copy(@discount.data)
		delete discount.customer_group
		delete discount.benefit.data
		typeId = discount.benefit.promotion_benefit_type_id

		discount.shops = _.pluck(_.filter(@shops, (shop) -> shop.selected), 'id')
		discount.shop_groups = _.pluck(_.filter(@shopGroups, (shopGroup) -> shopGroup.selected), 'id')
		discount.eligible_sets = []
		discount.allow_eligible_and_benefit = '1'
		discount.allow_other_promotions = '1'
		discount.required_coupon_type_id = @Guid.generate() if @mainCrud.isNewEntity

		if !@allowOnlyProductSelection[typeId] && !@allowProductAndCategorySelection[typeId]
			discount.benefit_products = []
			discount.benefit_product_categories = []
			@discount.data.benefit_products = []
			@discount.data.benefit_product_categories = []
			discount.qualification = {
				promotion_qualification_type_id: @qualificationTypes.SALES_VALUE,
				value_min: '1',
				should_qualify_in_sets: '1',
			}

			return discount

		discount.qualification = {
				promotion_qualification_type_id: @qualificationTypes.ITEM_SET,
				should_qualify_in_sets: '1',
		}

		discount.eligible_sets.push(
			{
				qualification: {
					promotion_qualification_type_id: @qualificationTypes.QUANTITY_OF_ANY_ELIGIBLE_ITEM,
					quantity_min: '0.001',
					should_qualify_in_sets: '1',
				},
			},
		)

		if @allowOnlyProductSelection[typeId] || !@useCategoriesForBenefits
			discount.eligible_sets[0].eligible_products = @PromotionCampaignService.getProcessedEligibleSetsForSave(discount.benefit_products)
			discount.benefit_products = @PromotionCampaignService.getProcessedBenefitProductsForSave(discount.benefit_products)

			discount.benefit_product_categories = []
			@discount.data.benefit_product_categories = []

			return discount

		if @allowProductAndCategorySelection[typeId]
			discount.benefit_products = []
			@discount.data.benefit_products = []
			discount.benefit_product_categories = _.map(
				discount.benefit_product_categories,
				(item) -> {product_category_id: item.id}
			)
			discount.eligible_sets[0].eligible_product_categories = angular.copy(discount.benefit_product_categories)

		return discount

	updateBenefitProductCategories: (changedPromotionProductCategories) ->
		@discount.data.benefit_product_categories = changedPromotionProductCategories

	resetBenefits: ->
		@discount.data.benefit_products = []
		@discount.data.benefit_product_categories = []

	initializeAllowedSelectionMaps: ->
		@allowOnlyProductSelection = {}
		@allowProductAndCategorySelection = {}

		for own key, value of @benefitTypes
			@allowOnlyProductSelection[value] = [
				@benefitTypes.FIXED_PRODUCT_PRICE,
			].includes(value)

			@allowProductAndCategorySelection[value] = [
				@benefitTypes.FREE_ITEM,
				@benefitTypes.FIXED_PRICE,
				@benefitTypes.PERCENTAGE_OFF_PER_ITEM,
			].includes(value)
